<template>
  <div class="candidate">
    <candidateHeader :showSetup="showSetup" />
    <router-view />
    <setupModal :show="showSetup" @close="skipSetup" />
    <password-change-modal />
  </div>
</template>

<script>
import setupModal from "@/components/candidate/modals/account-setup.vue";
import candidateHeader from "@/components/candidate/candidate-header.vue";
import PasswordChangeModal from "../components/candidate/modals/password-change.vue";
import { mapGetters } from "vuex";
export default {
  components: {
    candidateHeader,
    setupModal,
    PasswordChangeModal,
  },
  data() {
    return {};
  },
  watch: {},
  computed: {
    ...mapGetters({
      showSetup: "showSetup",
    }),
    userData() {
      return this.$store.state.userData;
    },
  },
  methods: {
    async fetchUserData() {
      let result = await this.$db.getDocument(
        "users",
        this.$store.state.user.uid
      );
      this.$store.commit("setUserData", result);
    },
    skipSetup() {
      this.$store.dispatch("toggleSetup", false);
      this.fetchUserData();
    },
  },
};
</script>

<style lang="scss">
body {
  background: #e8eaed !important;
}
</style>
